import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=8609cbb6&scoped=true&"
import script from "./AddProfile.vue?vue&type=script&lang=ts&"
export * from "./AddProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AddProfile.vue?vue&type=style&index=0&id=8609cbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8609cbb6",
  null
  
)

export default component.exports